export const bucketOf = (t?: string): "my" | "DOCUMENT_OPINION" | "DOCUMENT_APPROVAL" => {
    if (t === "DOCUMENT_APPROVAL") return "DOCUMENT_APPROVAL";
    if (t === "DOCUMENT_OPINION") return "DOCUMENT_OPINION";
    return "my";
};
